const config = {
  ENVIRONMENT_NAME: 'staging',
  forwoodId: {
    URL: 'https://id.staging.vale.forwoodsafety.com',
    USER_TOKEN_URL: 'https://mkpezi3wre.execute-api.us-east-2.amazonaws.com/prod'
  },
  apiGateway: {
    REGION: 'us-east-2',
    URL: 'https://ya58vsqn8a.execute-api.us-east-2.amazonaws.com/prod'
  },
  reactApp: {
    VERSION: 'admin-container-1.11.5',
    HOSTNAME: 'https://admin.staging.vale.forwoodsafety.com',
    COMPANY_MICROFRONTEND_URL: 'https://company.staging.vale.forwoodsafety.com',
    PHYSICAL_LOCATION_MICROFRONTEND_URL: 'https://locations.staging.vale.forwoodsafety.com'
  },
  configurationService: {
    URL: 'https://config.staging.vale.forwoodsafety.com',
    WEBSOCKET: 'wss://jiap0cb7vj.execute-api.us-east-2.amazonaws.com/staging'
  },
  get forwoodIdAuthUrl() {
    return `${this.forwoodId.URL}/authorize?response_type=token&scope=openid&client_id=${this.forwoodId.APP_CLIENT_ID}&redirect_uri=${this.reactApp.HOSTNAME}&state=`;
  }
};

export default config;
